var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6807\u9898") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u6807\\u9898",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C17.3137085,-6.08718376e-16 20,2.6862915 20,6 L20,14 C20,17.3137085 17.3137085,20 14,20 L6,20 C2.6862915,20 4.05812251e-16,17.3137085 0,14 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 L14,0 Z M14.8647838,4.15420226 L5.13607342,4.15420226 L4.15548797,8.05554368 L5.14678786,8.05554368 C5.28264694,6.97338537 6.20966018,6.13594484 7.31539026,6.13594484 L7.31539026,6.13594484 L9.02627183,6.13594484 L9.02627183,12.917756 C9.02419673,12.9683768 9.0261982,13.0191283 9.02627183,13.069901 C9.02627183,14.1640595 8.15368793,15.051215 7.07795829,15.051215 L7.07795829,15.051215 L7.07795829,15.8440835 L12.9220418,15.8440835 L12.9220418,15.051215 C11.8458835,15.051215 10.9737282,14.1640595 10.9737282,13.069901 C10.9738019,13.0191283 10.9758033,12.9683768 10.9797283,12.917756 L10.9797283,12.917756 L10.9737282,12.917756 L10.9737282,6.13594484 L12.6846098,6.13594484 C13.7989114,6.13594484 14.7182103,6.97595683 14.8536408,8.05554368 L14.8536408,8.05554368 L15.8449407,8.05554368 L14.8647838,4.15420226 Z",
    id: "\\u77E9\\u5F62-2",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.9dbc8ce6.svg";
export { ForwardRef as ReactComponent };